import { STATUS } from "#vacancy/constants"
import { Box, TextField, Typography } from "@mui/material"
import { useState } from "react"
import VacancyDialogStatus from "./VacancyDialogStatus"

import React from "react"

export default function VacancyDialogCanceled({ open, setOpen, profileData }) {
	const { id: vacanteId, perfil_puesto_name } = profileData || {}
	const [reason, setReason] = useState("")
	return (
		<VacancyDialogStatus
			{...{
				open,
				setOpen,
				vacanteId,
				status: STATUS.CANCELED,
				reason,
				title: "Cancelar Vacante",
			}}
		>
			<Box>
				<Typography variant="body1" sx={{ textAlign: "center" }}>
					¿Esta seguro que desea cancelar la vacante <strong>{perfil_puesto_name}</strong>
					?
				</Typography>
				<Typography variant="body2" sx={{ textAlign: "center" }} color="error.main">
					Esta acción no se puede deshacer.
				</Typography>
				<TextField
					label="Motivo"
					value={reason}
					onChange={(e) => setReason(e.target.value)}
					sx={{ width: "100%" }}
				/>
			</Box>
		</VacancyDialogStatus>
	)
}
